/* eslint-disable no-unused-vars */
import React, { useState, useMemo, useCallback } from "react";
import Table from "../../../components/Table/Table";
import { Header } from "../../../components";
import { ELProcessBaseColumns } from "../../../utils/utils";
import TicketButton from "../../../components/TableComponents/TicketButton/TicketButton";
import StatusBadge from "../../../components/TableComponents/StatusBadge/StatusBadge";
import ActionButtons from "../../../components/TableComponents/ActionButtons/ActionButtons";
import TableLayout from "../../../layouts/TableLayout/TableLayout";

import UpdateELModal from "../../../components/UpdateELModal/UpdateELModal";
import useTicketData from "../../../hooks/useTicketData";
import useTicketModal from "../../../hooks/useTicketModal";
import useTicketExport from "../../../hooks/useTicketExport";
import NoItemsFound from "../../../components/NoItemsFound/NoItemsFound";

function ELProcess() {

  // Custom hooks
  const {
    searchQuery,
    allRows: filteredRows,
    loading,
    isRefreshing,
    handleRefresh,
    handleSearchQuery,
    total,
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
  } = useTicketData("APPROVER_APPROVED", true); 

  const {
    isModalOpen,
    selectedTicketId,
    selectedTicketNumber,
    handleOpenModal,
    handleCloseModal,
    handleOnUpload,
  } = useTicketModal();

  const [selectTicketNumber, setSelectTicketNumber] = useState("");

  const handleActionClick = useCallback(
    (action, rowData) => {
      if (action === "Update EL") {

        setSelectTicketNumber(rowData);
        handleOpenModal();
      }
    },
    [handleOpenModal]
  );

  const columns = useMemo(() => {
    const updatedColumns = [...ELProcessBaseColumns];

    updatedColumns[0] = {
      width: 180,
      title: "Ticket Number",
      field: "ticketNumber",
      enableSearch: false,
      enableFilter: false,
      render: (rowData) => (
        <TicketButton
          ticketNumber={rowData.ticketNumber}
          ticketId={rowData.id}
        />
      ),
    };

    updatedColumns[3] = {
      width: 220,
      title: "Status",
      field: "status",
      enableSearch: false,
      enableFilter: false,
      render: (rowData) => <StatusBadge status={rowData.status} />,
    };

    updatedColumns[5] = {
      width: 220,
      title: "Action",
      field: "action",
      enableSearch: false,
      enableFilter: false,
      render: (rowData) => (
        <ActionButtons
          actions={["Update EL"]}
          status={rowData.status}
          onActionClick={(action) => handleActionClick(action, rowData)}
        />
      ),
    };

    return updatedColumns;
  }, [handleActionClick]);

  const { handleExport, isExporting } = useTicketExport(
    "APPROVER_APPROVED",
    columns
  );

  return (
    <TableLayout
      styles={{ tableInnerWrapper: { paddingBottom: "0rem" } }}

      header={
        <Header
          searchQuery={searchQuery}
          handleSearchQuery={handleSearchQuery}
          onRefresh={handleRefresh}
          isRefreshing={isRefreshing}
          onExport={handleExport}
          isExporting={isExporting}
          disableExport={filteredRows.length === 0}
        />
      }
    >
      {filteredRows.length === 0 && !(loading) ? (
        <NoItemsFound />
      ) : (
        <Table
          columns={columns}
          defaultColumns={columns}
          rows={filteredRows}
          hideCheckbox
          rowHeight={45}
          setHasActiveEdits={() => {}}
          isDataLoading={loading || isRefreshing}
          serverSide
          totalRows={total}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
      <UpdateELModal
        handleRefresh={handleRefresh}
        open={isModalOpen}
        onUpload={handleOnUpload}
        onClose={handleCloseModal}
        rowData={selectTicketNumber}
      />
    </TableLayout>
  );
}

ELProcess.propTypes = {};

export default ELProcess;
